export const postCodeRegex = /^\d{4}$/;
